// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import { withStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core/';

/* -----------------Nextjs--------------- */
import dynamic from 'next/dynamic';

/* -----------------Types--------------- */
import type {
  Image,
} from 'common/types';

/* -----------------Utils--------------- */
import { isEmpty } from 'common/simpleUtils';

/* -----------------Child components--------------- */
import ZoomImage from './ZoomImage';

const TermImages = dynamic(() => import('./TermImages'), { ssr: false });
const RenderMarkdown = dynamic(() => import('@components/common/RenderMarkdown'), { ssr: false });

/* -----------------Styles--------------- */
const styles = theme => ({
  markdownContainer: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 4,
    },
  },
  imageThumbnail: {
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      height: 150,
    },
  },
  termDetailsContainer: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(5),
    },
  },
});

/* -----------------Type declarations--------------- */
type Classes = {
  markdownContainer: string,
  imageThumbnail: string,
  termDetailsContainer: string,
};

/* -----------------Props--------------- */
type Props = {
    classes: Classes;
    termId: number,
    termName: string,
    termImages: Image[],
};

/* -----------------Component--------------- */
const TermDetails = (props: Props) => {
  const {
    termId,
    termImages,
    termName,
    classes,
  } = props;

  return (
    <Box
      flex={1}
      fontSize={16}
      fontWeight={600}
      maxWidth="100%"
      className={classes.termDetailsContainer}
    >
      {termImages.length === 1
        ? (
          <ZoomImage
            image={termImages[0]}
            thumbnailStyle={classes.imageThumbnail}
          />
        )
        : null }
      {termImages.length > 1
        ? <TermImages id={termId} images={termImages} />
        : null }
      {!isEmpty(termName)
        ? (
          <div className={classes.markdownContainer}>
            <Typography component="span">
              <RenderMarkdown
                source={termName}
                variant="term"
              />
            </Typography>
          </div>
        )
        : null}
    </Box>
  );
};

export default withStyles(styles)(TermDetails);
